
export const COLOR_PRIMARY = '#3E001C';
export const COLOR_SECONDARY = '#959597';
export const COLOR_INACTIVE = '#dbdbdb';
export const COLOR_BACKGROUND = '#FAFAFA';
